import { render, staticRenderFns } from "./EditColorCategory.vue?vue&type=template&id=d142fc12&"
import script from "./EditColorCategory.vue?vue&type=script&lang=js&"
export * from "./EditColorCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports